<template>
  <div class="versioning-ui">
    <div class="versioning-ui__container">
      <div @click="toggleUI" class="versioning-ui__tooltip">
        <span>Wersja: {{ version }}</span>
      </div>
      <div v-if="opened" class="versioning-ui__body">
        <TextInput :label="label" placeholder="IG-1234"
          v-model="selectedVersion" />
        <button @click="submit">Przejdź do wersji</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import TextInput from '@/components/forms/fields/TextInput'
import QueryString from '@/utils/QueryString'

@Component({
  components: {
    TextInput,
  },
  props: {
    version: {
      type: String,
      required: false,
      default: () => '',
    },
  },
})
export default class VersioningUI extends Vue {
  opened = false
  selectedVersion = ''
  label = 'Wybierz wersję frontendu'

  toggleUI () {
    this.opened = !this.opened
  }

  submit () {
    new QueryString().set('version', this.selectedVersion)
    window.location.reload()
  }
}
</script>

<style lang="scss" scoped>
.versioning-ui {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 10000;

  &__tooltip {
    color: #fff;
    background: #E71F6C;
    font-family: 'Gotham Book';
    font-weight: bold;
    padding: 8px 15px 3px 15px;
    border-radius: 5px 0 0;
    font-size: 13px;
  }

  &__container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  &__body {
    width: 400px;
    min-height: 80px;
    padding: 10px;
    background: #fff;
    border: 2px solid #E71F6C;
    border-radius: 5px 0 0;

    button {
      border: 2px solid;
      margin-top: 15px;
      background: transparent;
      padding: 5px 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VersioningUI.vue